import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';
import './CSS/style.css';
import { report_info, AllZonePlots } from './Javascript/ReportObjects'
import { generateZoneCharts } from './Javascript/GenerateReport'

interface Props {
    plot_data: report_info | null;
}

const ZonePlots: React.FC<Props> = ({plot_data}) => {
  const [is_loading, set_is_loading] = useState(true);
  const [all_zone_plots, set_all_zone_plots] = useState<AllZonePlots[] | null>(null);

  const plot_config = {
    responsive: true,
  }

  useEffect(() => {
      const fetchData = async () => {
          try {
              if (plot_data != null && all_zone_plots == null) {
                  set_all_zone_plots(generateZoneCharts(plot_data));
              }
          } catch (error) {
              console.error(error);
          } finally {
              if(all_zone_plots != null){
                  set_is_loading(false);
              }
          }
      };

      fetchData();
      }, [plot_data, all_zone_plots]);

  return (
    <div>
    {is_loading ? (
            <p> Generating Plots ... </p>
        ) : (
            (all_zone_plots === null || all_zone_plots === undefined || all_zone_plots.length === 0 || Object.keys(all_zone_plots).length === 0) ? (
                <p>No Zone plots available.</p>
            ) : (
                Object.entries(all_zone_plots).map(([index, { plot_name, plot_data }]) => {

                    if (!plot_data) {
                        return null;
                    }
                    return (
                        <div className="report_row" key={index}>
                            <div className="inner_padding">
                                <p className="sub_title">{plot_name}</p>
                                <div className="convert_to_image plot_type_1">
                                    <Plot
                                        data={plot_data.data}
                                        layout={plot_data.layout}
                                        config={plot_config}
                                        useResizeHandler={true}
                                        style={{ width: '100%', height: '100%' }}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })
            )
        )}
    </div>
  );
};

export default ZonePlots;